import React, { useEffect, useState, useRef } from "react";
import "./CampoLuzes.css";
import { LightGroup } from "../Classes/LightGroup";
import Ligado from "../../assets/img/Ligado.png";
import Desligado from "../../assets/img/Desligado.png";
import { getLuzesStatusFlex35, statusDasLuzesFlex35, getLuzesStatusFlex8, statusDasLuzesFlex8} from "../../API/FeedBackLuzes";

const GroupLightComponent = () => {
  const groupRefs = useRef({
    grupo05: React.createRef(),
    grupo06: React.createRef(),
    grupo11: React.createRef(),
    grupo33: React.createRef(),
    grupo34: React.createRef(),
    grupo35: React.createRef(),
    grupo36: React.createRef(),
    grupo37: React.createRef(),
    grupo39: React.createRef(),
    grupo40: React.createRef(),
    grupo41: React.createRef(),
  });

  const [imageStates, setImageStates] = useState({
    grupo05: false,
    grupo06: false,
    grupo11: false,
    grupo33: false,
    grupo34: false,
    grupo35: false,
    grupo36: false,
    grupo37: false,
    grupo39: false,
    grupo40: false,
    grupo41: false,
  });

  const [expanded, setExpanded] = useState({
    SanMarino: false,
    Positano: false,
    Outros: false,
  });

  const toggleExpand = (section) => {
    setExpanded((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setExpanded({
        SanMarino: false,
        Positano: false,
        Outros: false,
      });
    }, 30000); // 30000 ms = 30 seconds

    return () => clearInterval(intervalId);
  }, [expanded]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      await getLuzesStatusFlex35();
      const data = await getLuzesStatusFlex8();
      updateLightGroup(data);
      setLoading(false);
      console.log("Status das luzes Flex35:", statusDasLuzesFlex35);
      console.log("Status das luzes Flex8:", statusDasLuzesFlex8);
    };
    
    fetchData();

    const intervalId = setInterval(fetchData, 4200);
  
    return () => clearInterval(intervalId);
  }, []);


  const updateLightGroup = (data) => {
    setImageStates({
      grupo05: statusDasLuzesFlex35.includes("1E10") && !statusDasLuzesFlex35.includes("1E00"),
      grupo06: statusDasLuzesFlex35.includes("1F10") && !statusDasLuzesFlex35.includes("1F00"),
      grupo11: statusDasLuzesFlex35.includes("1K10") && !statusDasLuzesFlex35.includes("1K00"),
      grupo33: statusDasLuzesFlex35.includes("1g10") && !statusDasLuzesFlex35.includes("1g00"),
      grupo34: statusDasLuzesFlex35.includes("1h10") && !statusDasLuzesFlex35.includes("1h00"),
      grupo35: statusDasLuzesFlex35.includes("1i10") && !statusDasLuzesFlex35.includes("1i00"),
      grupo36: data[0].dados[0] === "ON",
      grupo37: data[0].dados[1] === "ON",
      grupo39: data[0].dados[3] === "ON",
      grupo40: data[0].dados[4] === "ON",
      grupo41: data[0].dados[5] === "ON",
    });

  };

  const handleToggleLightGroup = (groupId, newImageState) => {
    setImageStates(prevState => ({ ...prevState, [groupId]: newImageState }));
  };

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <>
      <div className="group" id="campoGroup-pagina2">

        {/* Grupo 5 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo05}
          groupId="grupo05"
          descricao="Circulação Inter."
          imageUrl={imageStates.grupo05 ? Ligado : Desligado}
          onCommand="1E10"
          offCommand="1E00"
          x={27.7}
          y={39.7}
          width={1.55}
          height={3}
          imageState={imageStates.grupo05}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 6 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo06}
          groupId="grupo06"
          descricao="Circulação Externa"
          imageUrl={imageStates.grupo06 ? Ligado : Desligado}
          onCommand="1F10"
          offCommand="1F00"
          x={34.9}
          y={39.9}
          width={1.55}
          height={3}
          imageState={imageStates.grupo06}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 11 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo11}
          groupId="grupo11"
          descricao="Circulação Interm."
          imageUrl={imageStates.grupo11 ? Ligado : Desligado}
          onCommand="1K10"
          offCommand="1K00"
          x={63.55}
          y={49.7}
          width={1.55}
          height={3}
          imageState={imageStates.grupo11}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 33 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo33}
          groupId="grupo33"
          descricao="Jardim Fundos 1"
          imageUrl={imageStates.grupo33 ? Ligado : Desligado}
          onCommand="1a10"
          offCommand="1a00"
          x={79.15}
          y={54.65}
          width={1.55}
          height={3}
          imageState={imageStates.grupo33}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 34 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo34}
          groupId="grupo34"
          descricao="Jardim Fundos 2"
          imageUrl={imageStates.grupo34 ? Ligado : Desligado}
          onCommand="1b10"
          offCommand="1b00"
          x={86}
          y={61.4}
          width={1.55}
          height={3}
          imageState={imageStates.grupo34}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 35 */}
        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo35}
          groupId="grupo35"
          descricao="Escadarias Fundos"
          imageUrl={imageStates.grupo35 ? Ligado : Desligado}
          onCommand="1c10"
          offCommand="1c00"
          x={76.4}
          y={54.4}
          width={1.55}
          height={3}
          imageState={imageStates.grupo35}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 36 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo36}
          groupId="grupo36"
          descricao="Garden Gourmet 1"
          imageUrl={imageStates.grupo36 ? Ligado : Desligado}
          onCommand={{ modulo: "1" , idx: "1", status: "ON"}}
          offCommand={{ modulo: "1" , idx: "1", status: "OFF"}}
          x={88}
          y={63.45}
          width={1.55}
          height={3}
          imageState={imageStates.grupo36}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 37 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo37}
          groupId="grupo37"
          descricao="Garden Gourmet 2"
          imageUrl={imageStates.grupo37 ? Ligado : Desligado}
          onCommand={{ modulo: "1" , idx: "2", status: "ON"}}
          offCommand={{ modulo: "1" , idx: "2", status: "OFF"}}
          x={86.1}
          y={65}
          width={1.55}
          height={3}
          imageState={imageStates.grupo37}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 39 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo39}
          groupId="grupo39"
          descricao="Piscina Garden"
          imageUrl={imageStates.grupo39 ? Ligado : Desligado}
          onCommand={{ modulo: "1" , idx: "4", status: "ON"}}
          offCommand={{ modulo: "1" , idx: "4", status: "OFF"}}
          x={78.9}
          y={60.9}
          width={1.55}
          height={3}
          imageState={imageStates.grupo39}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 40 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo40}
          groupId="grupo40"
          descricao="Poste Fundos 1"
          imageUrl={imageStates.grupo40 ? Ligado : Desligado}
          onCommand={{ modulo: "1" , idx: "5", status: "ON"}}
          offCommand={{ modulo: "1" , idx: "5", status: "OFF"}}
          x={75.7}
          y={34.1}
          width={1.55}
          height={3}
          imageState={imageStates.grupo40}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Grupo 41 */}

        <LightGroup
          className="light_button"
          ref={groupRefs.current.grupo41}
          groupId="grupo41"
          descricao="Poste Fundos 2"
          imageUrl={imageStates.grupo41 ? Ligado : Desligado}
          onCommand={{ modulo: "1" , idx: "6", status: "ON"}}
          offCommand={{ modulo: "1" , idx: "6", status: "OFF"}}
          x={77.65}
          y={42.55}
          width={1.55}
          height={3}
          imageState={imageStates.grupo41}
          onToggleLightGroup={handleToggleLightGroup}
        />

        {/* Legenda de acionamentos */}

        <div className={`Topico-Menubar-SanInter${expanded.SanMarino ? '-expanded' : ''}`}>
            <p className={`topicoParagrafoMenuBar${expanded.SanMarino ? '-expanded' : ''}`} onClick={() => toggleExpand('SanMarino')}>
              <b>Torre San Marino</b>
            </p>
          {expanded.SanMarino && (
            <div id="SanMarino-intermedio">
              <div
                className="clickable-element"
                onClick={() => {handleToggleLightGroup('grupo05', !imageStates.grupo05); groupRefs.current.grupo05.current.sendCommand(groupRefs.current.grupo05.current.props.descricao, imageStates.grupo05 ? groupRefs.current.grupo05.current.props.offCommand : groupRefs.current.grupo05.current.props.onCommand);
                }}
              >
                <p className={`NumberTextBar${imageStates.grupo05 ? 'Highlighted' : ''}`}>5</p>
                <p className="textBar">Circulação Interm.</p>
              </div>

              <div
                className="clickable-element-last"
                onClick={() => {handleToggleLightGroup('grupo06', !imageStates.grupo06); groupRefs.current.grupo06.current.sendCommand(groupRefs.current.grupo06.current.props.descricao, imageStates.grupo06 ? groupRefs.current.grupo06.current.props.offCommand : groupRefs.current.grupo06.current.props.onCommand);
                }}
              >
                <p className={`NumberTextBar-last${imageStates.grupo06 ? 'Highlighted' : ''}`}>6</p>
                <p className="textBar">Circulação Externa</p>
              </div>
            </div>
          )}
        </div>
        <div className={`Topico-Menubar-PositanoInter${expanded.Positano ? '-expanded' : ''}`}>
          <p className={`topicoParagrafoMenuBar${expanded.Positano ? '-expanded' : ''}`} onClick={() => toggleExpand('Positano')}>
              <b>Torre Positano</b>
            </p>
            {expanded.Positano && (
              <div id="positano-intermedio">
                <div
                  className="clickable-element-last"
                  style={{ top: '76.4%', left: '80%' }}
                  onClick={() => {handleToggleLightGroup('grupo11', !imageStates.grupo11); groupRefs.current.grupo11.current.sendCommand(groupRefs.current.grupo11.current.props.descricao, imageStates.grupo11 ? groupRefs.current.grupo11.current.props.offCommand : groupRefs.current.grupo11.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar-last${imageStates.grupo11 ? 'Highlighted' : ''}`}>11</p>
                  <p className="textBar">Circulação Interm.</p>
                </div>
              </div> 
            )}
          </div>
          <div className={`Topico-MenubarOthers-Intermedio${expanded.Outros ? '-expanded' : ''}`}>
            <p className={`topicoParagrafoMenuBar${expanded.Outros ? '-expanded' : ''}`} onClick={() => toggleExpand('Outros')}>
              <b>Outros</b>
            </p>

            {expanded.Outros && (
              <div id="outros-intermedio">
                <div
                  className="clickable-element"
                  style={{ top: '76.4%', left: '80%' }}
                  onClick={() => {handleToggleLightGroup('grupo33', !imageStates.grupo33); groupRefs.current.grupo33.current.sendCommand(groupRefs.current.grupo33.current.props.descricao, imageStates.grupo33 ? groupRefs.current.grupo33.current.props.offCommand : groupRefs.current.grupo33.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo33 ? 'Highlighted' : ''}`}>33</p>
                  <p className="textBar">Jardim Fundos 1</p>
                </div>

                <div
                  className="clickable-element"
                  
                  onClick={() => {handleToggleLightGroup('grupo34', !imageStates.grupo34); groupRefs.current.grupo34.current.sendCommand(groupRefs.current.grupo34.current.props.descricao, imageStates.grupo34 ? groupRefs.current.grupo34.current.props.offCommand : groupRefs.current.grupo34.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo34 ? 'Highlighted' : ''}`}>34</p>
                  <p className="textBar">Jardim Fundos 2</p>
                </div>

                <div
                  className="clickable-element"
                  onClick={() => {handleToggleLightGroup('grupo35', !imageStates.grupo35); groupRefs.current.grupo35.current.sendCommand(groupRefs.current.grupo35.current.props.descricao, imageStates.grupo35 ? groupRefs.current.grupo35.current.props.offCommand : groupRefs.current.grupo35.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo35 ? 'Highlighted' : ''}`}>35</p>
                  <p className="textBar">Escadarias Fundos</p>
                </div>

                <div
                  className="clickable-element"
                  onClick={() => {handleToggleLightGroup('grupo36', !imageStates.grupo36); groupRefs.current.grupo36.current.sendCommand(groupRefs.current.grupo36.current.props.descricao, imageStates.grupo36 ? groupRefs.current.grupo36.current.props.offCommand : groupRefs.current.grupo36.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo36 ? 'Highlighted' : ''}`}>36</p>
                  <p className="textBar">Garden Gourmet 1</p>
                </div>

                <div
                  className="clickable-element"
                  onClick={() => {handleToggleLightGroup('grupo37', !imageStates.grupo37); groupRefs.current.grupo37.current.sendCommand(groupRefs.current.grupo37.current.props.descricao, imageStates.grupo37 ? groupRefs.current.grupo37.current.props.offCommand : groupRefs.current.grupo37.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo37 ? 'Highlighted' : ''}`}>37</p>
                  <p className="textBar">Garden Gourmet 2</p>
                </div>

                <div
                  className="clickable-element"
                  onClick={() => {handleToggleLightGroup('grupo39', !imageStates.grupo39); groupRefs.current.grupo39.current.sendCommand(groupRefs.current.grupo39.current.props.descricao, imageStates.grupo39 ? groupRefs.current.grupo39.current.props.offCommand : groupRefs.current.grupo39.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo39 ? 'Highlighted' : ''}`}>39</p>
                  <p className="textBar">Piscina Garden</p>
                </div>

                <div
                  className="clickable-element"
                  onClick={() => {handleToggleLightGroup('grupo40', !imageStates.grupo40); groupRefs.current.grupo40.current.sendCommand(groupRefs.current.grupo40.current.props.descricao, imageStates.grupo40 ? groupRefs.current.grupo40.current.props.offCommand : groupRefs.current.grupo40.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar${imageStates.grupo40 ? 'Highlighted' : ''}`}>40</p>
                  <p className="textBar">Poste Fundos 1</p>
                </div>

                <div
                  className="clickable-element-last"
                  onClick={() => {handleToggleLightGroup('grupo41', !imageStates.grupo41); groupRefs.current.grupo41.current.sendCommand(groupRefs.current.grupo41.current.props.descricao, imageStates.grupo41 ? groupRefs.current.grupo41.current.props.offCommand : groupRefs.current.grupo41.current.props.onCommand);
                  }}
                >
                  <p className={`NumberTextBar-last${imageStates.grupo41 ? 'Highlighted' : ''}`}>41</p>
                  <p className="textBar">Poste Fundos 2</p>
                </div>
              </div>
            )}
          </div>
      </div>
    </>
  );
};

export default React.memo(GroupLightComponent);